
import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"

import defaultCover from "../../images/cover.jpg"

function SEO({
  description = "",
  lang = "en",
  meta = [],
  title = "Here Snowfall in December",
  image = defaultCover,
}) {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: image,
        },
        {
          property: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          property: `twitter:creator`,
          content: "@zcreativelabs",
        },
        {
          property: `twitter:title`,
          content: title,
        },
        {
          property: `twitter:description`,
          content: description,
        },
        {
          property: `twitter:image`,
          content: image,
        },
      ].concat(meta)}
    >
      <link rel="canonical" href="https://snowfall-in-december.netlify.com/" />
    </Helmet>
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default SEO
